export const getData = (key) => {
    return  sessionStorage.getItem(key);
}

export const setData = (key, value) => {
   sessionStorage.setItem(key, value);
}